import cookies, {CookieAttributes} from "js-cookie";
import {IS_REGULAIT, MAX_LIVE_COOKIE, PATH_ARI} from "../../constants";
import {Logging} from "../../utils/logs/log";


export const useCookies = () => {
    const getCookieByName = (name: string): string | null => {
        const res = cookies.get(name);
        if(!res) return null;
        try{
            return res;
        }catch (ex: any){
            // ex && console.log(`useCookies: getCookieByName error ${JSON.stringify(ex.message)}`);
        }
        return null;
    }

    const setCookieByName = (name: string, value: string): void => {
        cookies.set(name, value, getOptions());
        // console.log(`COOKIE SET WITH NAME ${name} : ${res}`);
    }

    const deleteCookieByName = (name: string): void => {
        Logging.log(`---useCookies removing cookie ${name}`);
        cookies.remove(name, getOptions());
    }

    const updateCookieByName = (name: string, value: string): void => {
        // console.log(`COOKIE UPDATED WITH NAME: ${name} AND value: ${value}`);
        cookies.remove(name, getOptions());
        cookies.set(name, value, getOptions());
    }

    const getOptions = (): CookieAttributes => {
        if(PATH_ARI === 'http://localhost:3000'){
            return {};
        }

         let options: CookieAttributes = {
            expires: new Date(Date.now() + MAX_LIVE_COOKIE),
            domain: IS_REGULAIT ? 'regulait.com' : 'complico.me',
            secure: false,
            signed: true,
            httpOnly: false,
            sameSite: 'strict'
        };
        // console.log(options);
         return options;
    }

    // console.log(`AUTH_COOKIE ------ ${cookies.get('auth-cookie')}`);
    return{
        getCookieByName,
        setCookieByName,
        updateCookieByName,
        deleteCookieByName,
    }
}